<template>
  <div class="public-attachments" v-if="items">
    <md-card class="md-card-unspaced public-attachment-card rfider-shadow">
      <md-card-content>
        <md-subheader class="public-attachment-card-header"
          ><span> {{ $t('public.attachments_title') }}</span>
        </md-subheader>
        <div
          v-for="(attach, index) in items"
          :key="index"
          class="md-layout md-alignment-center-center public-attachment-card-list"
        >
          <div class="md-layout-item md-layout-item--no-grow">
            <md-icon
              :class="'rfider-icon icon-extension-' + attach.className"
            ></md-icon>
          </div>
          <div class="md-layout-item public-attachment-card-title">
            <a :href="attach.file" target="_blank">{{
              attach.name ? attach.name : 'Unnamed File'
            }}</a>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import * as FileExt from '@/utils/FileExtensions';
export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  watch: {
    items: {
      immediate: true,
      handler(newItem) {
        newItem.map((attach) => {
          attach.file = attach.file
            ? this.mixinGetFilePath(attach.file, 'O')
            : null;
          attach.className = FileExt.getFileExtension(attach.file);
        });
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/components/public/_public-attachments.scss';
</style>
